import { Component, OnInit } from '@angular/core';
import { IWidgetEditor, WidgetType, ChartWidget } from "src/app/models/dashboard";
import { Widget, Dashboard } from 'src/api/models'
import { StorageTablesService } from "src/service/storage-tables.service";
import { ApplicationConfigService } from "src/service/application-config.service";

@Component({
  selector: "app-table-widget-editor",
  templateUrl: "./table-widget-editor.component.html",
  styleUrls: ["./table-widget-editor.component.css"],
})
export class TableWidgetEditorComponent implements OnInit, IWidgetEditor {
  public widgetType: WidgetType;
  public widget: ChartWidget;
  public dashboard: Dashboard;
  public w: any;

  private colours: string[];

  constructor(public storageTablesService: StorageTablesService, public app: ApplicationConfigService) {
    this.colours = app.colours;
  }

  ngOnInit() {
    this.w = this.widget;
    if (this.w.tableDetailList == null){
      this.w.tableDetailList = [];
    }
    var i = 0;
    for (let tab of this.w.tableDetailList) {
      tab.removable = true;
      if (tab.transforms == null){
        tab.transforms = [];
      }
      i++;
    }
  }

  public duplicate(timeSeries: any): void {
    var newEntry = JSON.stringify(timeSeries)
    this.w.tableDetailList.push(JSON.parse(newEntry));
  }

  public addTimeSeries() {
    this.w.tableDetailList.push({
      uri: null,
      active: true,
      transforms: [],
      zoneColours: []
    });
  }

  public removeTimeSeries(timeSeries: any): void {
    var index = this.w.tableDetailList.indexOf(timeSeries);
    if (index > -1) {
      this.w.tableDetailList.splice(index, 1);
    }
  }

  public addZoneColor(ts) {
    if(ts.zoneColours == null){
      ts.zoneColours = [];
    }
    ts.zoneColours.push({ min:0, max:0, colour: this.findPreviousColour(ts)});
  }

  public removeZoneColour(ts, zoneObj){
    var index = ts.zoneColours.indexOf(zoneObj);
    if (index > -1) {
      ts.zoneColours.splice(index, 1);
    }
  }

  private findPreviousColour(ts):string{
    let returnColour = this.colours[0];
    const index = ts.zoneColours.length -1;
    //if return default colour when the zoneColors has not existing item.
    if(index == -1) return returnColour;
    try { 
      returnColour = ts.zoneColours[index].colour;
      }catch (err){
      console.error(err);
      return returnColour;
    }
    return returnColour;
  }
  
}
